'use es6';

import I18n from 'I18n';
import { Link } from 'foundations-components/transitional/components/Link';
import { RESEND_VERIFICATION_EMAIL_BUTTON_ID } from '../constants/DOMSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ResendVerificationEmailButton = () => /*#__PURE__*/_jsx(Link, {
  id: RESEND_VERIFICATION_EMAIL_BUTTON_ID,
  underline: true,
  children: I18n.text('emailConfirmBar.resendButton')
});
export default ResendVerificationEmailButton;